import api from "@sim/services/api";
import router from "@sim/router";
import localStorage from "@sim/services/storage";

export default {
  name: "SimStep6",

  mounted() {
  },

  methods: {
  },
};
